// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_overlay.styl
// module id = 80
// module chunks = 0